// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"977c1f08","85":"ea6e5683","145":"7a771ee1","219":"00c99434","351":"02c93872","435":"42617d95","570":"6792b9b2","606":"c4e19629","641":"20799113","689":"cfc998be","830":"b821c231","906":"8de6afb7","955":"cba1a73b","965":"ccca7e6e"}[chunkId] + ".chunk.js";
};